import { CosmosBaseQueryV1Beta1Pagination } from '@injectivelabs/core-proto-ts';
export class ChainGrpcCommonTransformer {
    static grpcCoinToCoin(coin) {
        return {
            denom: coin.denom,
            amount: coin.amount,
        };
    }
    static pageRequestToGrpcPageRequest(pageRequest) {
        const paginationForRequest = CosmosBaseQueryV1Beta1Pagination.PageRequest.create();
        if (!pageRequest) {
            return;
        }
        if (pageRequest.key) {
            paginationForRequest.key = Buffer.from(pageRequest.key, 'base64');
        }
        if (pageRequest.limit !== undefined) {
            paginationForRequest.limit = pageRequest.limit.toString();
        }
        if (pageRequest.offset !== undefined) {
            paginationForRequest.offset = pageRequest.offset.toString();
        }
        if (pageRequest.reverse !== undefined) {
            paginationForRequest.reverse = pageRequest.reverse;
        }
        if (pageRequest.countTotal !== undefined) {
            paginationForRequest.countTotal = pageRequest.countTotal;
        }
        return paginationForRequest;
    }
    static paginationUint8ArrayToString(key) {
        if (!key) {
            return '';
        }
        if (key.constructor !== Uint8Array) {
            return key;
        }
        return Buffer.from(key).toString('base64');
    }
    static grpcPaginationToPagination(pagination) {
        return {
            total: pagination
                ? parseInt(ChainGrpcCommonTransformer.paginationUint8ArrayToString(pagination.total), 10)
                : 0,
            next: pagination
                ? ChainGrpcCommonTransformer.paginationUint8ArrayToString(pagination.nextKey)
                : '',
        };
    }
}
